export class GridDataEntity {
  data: { [id: string]: any; }[] = [];
  total: number;
}
